import { render, staticRenderFns } from "./detailShow.vue?vue&type=template&id=0516853c&scoped=true"
import script from "./detailShow.vue?vue&type=script&lang=js"
export * from "./detailShow.vue?vue&type=script&lang=js"
import style0 from "./detailShow.vue?vue&type=style&index=0&id=0516853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516853c",
  null
  
)

export default component.exports